import type * as v from "@badrap/valita";

export const firstIssue = <T>(
  result: Extract<v.ValitaResult<T>, { ok: false }>,
): string => {
  for (const issue of result.issues) {
    if (issue.code === "custom_error") {
      if (issue.message === undefined) {
        continue;
      }

      return issue.message;
    }
  }

  return result.message;
};
